// test128
(128 && 0);
